import { Outlet } from 'react-router-dom'

// Auth pages manage their own layout.
// LoginView uses a full-screen two-panel layout; other pages self-center.
export function AuthLayout() {
  return <Outlet />
}
